// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"198":"1336d505","267":"66c7cca9","305":"f828c2ea","810":"0805665b"}[chunkId] + ".chunk.css";
};